@if (loading) {
  <!-- Add a loading indicator if needed -->
} @else if (navigationProducts.length === 0) {
  <div class="flex w-full items-center justify-center">No products configured for this client. Please contact accesso's Client Success Manager.</div>
} @else {
  <div class="main-wrapper">
    <div class="page-wrapper">
      @if (router.url === '/portal' && isAdvancedMenuEnabled) {
        <app-product-cards [navigationProducts]="navigationProducts" (selectedProduct)="navigateToProduct($event)"> </app-product-cards>
      } @else {
        <div class="side-bar-wrapper">
          <app-sidebar [navigationProducts]="selectedProductTree" [advancedMenuEnabled]="isAdvancedMenuEnabled"></app-sidebar>
        </div>
        <div class="content-wrapper" #contentWrapper contentAnimate [style]="{ 'padding-top': isAdvancedMenuEnabled ? '0px' : '40px' }">
          @if (isAdvancedMenuEnabled) {
            <div class="content-header-section py-4">
              <app-breadcrumbs class="mb-2 block"></app-breadcrumbs>
            </div>
          }
          <router-outlet></router-outlet>
        </div>
      }
    </div>

    @if (isAdvancedMenuEnabled) {
      <app-chatbox></app-chatbox>
    }
  </div>
}
